import script from "./rec-link-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-link-button.vue?vue&type=script&lang=ts&setup=true"

import "./rec-link-button.vue?vue&type=style&index=0&id=2d9f1aa3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9f1aa3"]])

export default __exports__